import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const ThankYouNoTrialPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { student } = location.state || {};

  const handleGoToDashboard = () => {
    navigate('/parentdashboard');
  };

  const handleRegisterAnotherStudent = () => {
    navigate('/studentregistration');
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography component="h1" variant="h5" gutterBottom>
          Registration Complete
        </Typography>
        <Box mt={2}>
          {student ? (
            <Typography variant="body1">
              {student.firstname} has been registered successfully, you have already used your free trial. To enable {student.firstname} to access to our learning resources, please visit your parent dashboard and add a subscription.
            </Typography>
          ) : (
            <Typography variant="body1">
              The student has been registered successfully, you have already used your free trial. To enable {student.firstname} to access to our learning resources please visit your parent dashboard and add a subscription.
            </Typography>
          )}
        </Box>
        <Box mt={4} display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Button variant="contained" color="primary" onClick={handleGoToDashboard}>
            Go to Parent Dashboard
          </Button>
          <Button variant="outlined" color="primary" onClick={handleRegisterAnotherStudent}>
            Register Another Student
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ThankYouNoTrialPage;
